// extracted by css-extract-rspack-plugin
export default {"diffValues":"cmCwpAltvu4NklCv","diffBefore":"NQD8DsA8gIyMvnKb","diffArrow":"y8MSpGvg8gXxHy2d","diffAfter":"E7Dpd8IEwckAEyEP"};